import { Component, OnInit, ViewChild } from '@angular/core';
import { verificationDoc } from '@app/_models/verificationDoc';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { LogService } from '../../_shared/log.service';
import { DatePipe } from '@angular/common'
import { DataTableDirective } from 'angular-datatables';
import { VerifyDocumentEventServiceService } from '@app/_services/verify-document-event-service.service';
import { statusRemark } from '@app/_models/statusRemark';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';

@Component({
  selector: 'app-employer-verification-list',
  templateUrl: './employer-verification-list.component.html',
  styleUrls: ['./employer-verification-list.component.css']
})
export class EmployerVerificationListComponent implements OnInit {

  dtTrigger: Subject<any> = new Subject<any>();
  request: verificationDoc[];
  requestNew: verificationDoc[];
  msgOnButtonClick: string;
  msgOnChildCompInit: String;
  fromDate: string;
  toDate: string;
  hideId = false;
  statusRemark = new statusRemark();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  receiveAutoMsgHandler(p) {

    var i = 0;
    this.msgOnChildCompInit = p;
    this.fromDate = p.fromDatee;
    this.toDate = p.toDatee;
    // alert(p.fromDatee)
    var userId = localStorage.getItem('user_id');
    // var userId = 3;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order:[[0, 'application_id']]
    };
    console.log(userId)

    var str = 'UN_';
    var str2 = 'UN_';

    this.verifyDocService.getVerificationDocsEmployee(userId, this.fromDate, this.toDate)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)

          this.request = data.respData;
          this.requestNew = data.respData;

          // display only Open when login
          this.request = this.requestNew;
          // const v = this.request.filter(m => !m.doc_status.includes("UN_") )
          const v = this.request.filter(m => m.doc_status=='Rejected'||m.doc_status=='Approved' || m.doc_status=='SV_Approved'  || m.doc_status=='SV_Rejected' ||m.doc_status=='Requested' || m.doc_status=='Unable To Verify'|| m.doc_status=='Offline'|| m.doc_status=='SV_Unable To Verify'|| m.doc_status=='SV_Offline' || m.doc_status=='Ver_Request_Edit' || m.doc_status=='Uni_Request_Edit')

          this.request = v;

          console.log(this.request)
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        })
  }

  receivedMessageHandler(p) {
    this.msgOnButtonClick = p;
    //alert('this.msgOnButtonClick  '+this.msgOnButtonClick);

    var userId = localStorage.getItem('user_id');
    this.verifyDocService.getVerificationDocsEmployee(userId, p.fromDatee, p.toDatee)
    .pipe(first())
    .subscribe(
      data => {
        console.log("response---", data)
        this.request = data.respData;
        this.requestNew = data.respData;
        console.log(this.request)
         if (p.status == 'Closed') {
          this.request = this.requestNew;
          const v = this.request.filter(m =>m.doc_status=='UN_Approved' ||m.doc_status=='UN_Approved_Pass'||m.doc_status=='UN_Approved_Fail'||m.doc_status=='UN_Rejected' || m.doc_status=='Uni_Auto_Approved'|| m.doc_status=='Uni_Auto_Rejected'|| m.doc_status=='SVD_Rejected'|| m.doc_status=='SVD_Approved' || m.doc_status=='SVD_Approved_Pass'|| m.doc_status=='SVD_Approved_Fail')
          // const v = this.request.filter(m => m.doc_status.includes("UN_"))
          this.request = v;

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
          });
        }
        else if (p.status == 'Open') {
          this.request = this.requestNew;
           const v = this.request.filter(m => m.doc_status=='Rejected'||m.doc_status=='Approved' || m.doc_status=='SV_Approved'||m.doc_status=='Approved_Pass' || m.doc_status=='SV_Approved_Pass'  ||m.doc_status=='Approved_Fail' || m.doc_status=='SV_Approved_Fail'    || m.doc_status=='SV_Rejected' ||m.doc_status=='Requested' || m.doc_status=='Unable To Verify'|| m.doc_status=='Offline'|| m.doc_status=='SV_Unable To Verify'|| m.doc_status=='SV_Offline' || m.doc_status=='Ver_Request_Edit' || m.doc_status=='Uni_Request_Edit')
          //const v = this.request.filter(m => !m.doc_status.includes("UN_"))
          this.request = v;

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();
            // Call the dtTrigger to rerender again
            this.dtTrigger.next();
          });
        }
        else {
          // this.request = this.requestNew;
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next();
          });
        }
      },
      error => {
        console.log(error)
      })



  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }



  title = 'docVerification';
  dtOptions: DataTables.Settings = {};

  constructor(private eventService: LogService, private verifyDocService: VerifyDocumentService, 
    public datepipe: DatePipe,private verifyDocumentEventServiceService: VerifyDocumentEventServiceService,
    private documentVerificationListService: DocumentVerificationListService) { }

    
  editVerification(dataValue, routeVal) {
    console.log("dataval==", dataValue, "routeVal===", routeVal)
    this.eventService.emit<string>(routeVal)
    this.verifyDocumentEventServiceService.emit<any>(dataValue)
  }



  callDispute(dataValue) {
    this.eventService.emit<string>(dataValue)
  }

  ngOnInit(): void {

    // alert('this.msgOnButtonClick  '+this.msgOnButtonClick);

  }

  downloadPDF(element) {
    this.verifyDocService.getPDF(element)
      .subscribe(
        (data: Blob) => {
          var file = new Blob([data], { type: 'application/pdf' })
          var fileURL = URL.createObjectURL(file);

          var currentDate = new Date()

          // this.date=new Date();
          let latest_date = this.datepipe.transform(currentDate, 'yyyy-MM-dd');

          // if you want to open PDF in new tab
          // window.open(fileURL); 
          var a = document.createElement('a');
          a.href = fileURL;
          a.target = element + '_' + latest_date;
          a.download = element + '_' + latest_date + '.pdf';
          document.body.appendChild(a);
          a.click();
        },
        (error) => {
          console.log('getPDF error: ', error);
        }
      );
  }

  downloadCertificate(id, status) {

    console.log("in DOWNLOAD" + id + status);

    this.statusRemark.id = id;
    this.statusRemark.status = status;

    console.log("in STATUS RMK" + this.statusRemark.id + this.statusRemark.status + "ALL" + JSON.stringify(this.statusRemark));

    this.documentVerificationListService.getPDF(this.statusRemark)
    .subscribe(
      (data: Blob) => {
        var file = new Blob([data], { type: 'application/pdf' })
        var fileURL = URL.createObjectURL(file);

        var currentDate = new Date()

        // this.date=new Date();
        let latest_date = this.datepipe.transform(currentDate, 'yyyy-MM-dd');

        // if you want to open PDF in new tab
         window.open(fileURL); 
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = id + '_' + latest_date;
        a.download = id + '_' + latest_date + '.pdf';
        document.body.appendChild(a);
        a.click();
      },
      (error) => {
        console.log('getPDF error: ', error);
      }
    );

}


}
